<template>
  <div class="show-upload-image">
    <el-image :style="styleImage"
              :src="src"
              fit="cover"></el-image>
    <!-- <div slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
    <div>
      <el-upload :name="file_name"
                 :action="$ip + `/${api_name}?key_name=${image_type_name}`"
                 :show-file-list="false"
                 :with-credentials="true"
                 :accept="accept"
                 :before-upload="beforeUpload"
                 :on-success="handleSuccess">
        <el-button slot="trigger"
                   :style="styleBottom"
                   class="upload-button">{{ button_name }}</el-button>
      </el-upload>

    </div>
  </div>
</template>

<script>
export default {
  name: 'show-image-and-upload',
  data() {
    return {
      file_name: 'image',
      accept: this.accept_format,
      styleImage: `width: 100%; height:${this.imageHeight}px`,
      styleBottom: `bottom:${this.bottomHeight}`,
    }
  },
  props: {
    src: '',
    bottomHeight: {
      type: String,
      default: '10%',
    },
    imageHeight: {
      type: String,
      default: '200',
    },
    api_name: {
      type: String,
      default: 'traver_point_add_image',
    },
    image_type_name: {
      type: String,
      default: 'vue-show-image-and-upload',
    },
    accept_format: {
      type: String,
      default: '.jpg, .jpeg, .png, .gif',
    },
    button_name: {
      type: String,
      default: '更换封面',
    },
  },
  methods: {
    beforeUpload(file) {
      // console.log(file);
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isFORMAT) {
        this.$message.error(`上传头像图片只能是 ${accept_format} 格式!`)
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      // console.log(file);
      return isFORMAT && isLt2M
    },
    // 【上传成功】时的钩子函数，将返回值添加到页面中
    handleSuccess(res, file) {
      if (res.errno == '4101' || res.errno == '4602') {
        this.$notify({
          title: '警告',
          message: res.errmsg,
          type: 'warning',
        })
        return
      } else if (res.errno == '0') {
        this.image_url = res.data.image_url
        this.imageUrl = URL.createObjectURL(file.raw) // 让图片可以展示在前端
        // 发送事件给父组件
        // console.log(this.image_url)
        this.$emit('getImageURl', this.image_url)
      }
    },
  },
}
</script>

<style>
.show-upload-image {
  position: relative;
}

.upload-button {
  position: absolute;
  font-size: 13px;
  text-align: center;
  width: 100%;
  color: #fff;
  padding: 5px 10px;
  background-color: rgba(255, 73, 1, 0.5);
}
</style>